module.exports = __webpack_public_path__ + "static/media/video-1.4b67b079.jpg";